
/*
* Copyright (c) 2021 EGT Digital - All rights reserved.
* 
* File: balance.ts
* 
* Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  08.11.22 3:04 pm.
* Last modified: 08.11.22 3:04 pm.
* 
* More information at: https://egt-digital.com/
*/
import IBalance from "../interfaces/IBalance";
import IExternalBalance from "../interfaces/IExternalBalance";
import { formatCurrencyValue } from "./helpers";

export const parseBalanceResponse = (balanceValue: IExternalBalance): IBalance => {
    const balance: IBalance = {
        balance: balanceValue.balance,
        formattedBalance: formatCurrencyValue(balanceValue.balance, balanceValue.units),
        units: balanceValue.units,
        currency: balanceValue.currency,
    };

    return balance;
};
